export enum ThirdPartyProviderString {
  apple = 'Apple',
  google = 'Google',
}
